import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { OrdersListPhase } from '@/types/ordersList'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'

interface OrderListSectionHeaderProps {
    phase: OrdersListPhase
    style?: StyleProp<ViewStyle>
}

const OrdersListSectionHeader: FC<OrderListSectionHeaderProps> = ({ phase, style }) => {
    const isOrdersLoaded = useAppSelector(ordersSelectors.isOrdersLoaded)
    const count = useAppSelector(ordersSelectors.countByPhase(phase))

    const { t } = useTranslation()

    return (
        <View style={[styles.container, style]}>
            <Text style={styles.title}>{t(`ordersList.section.${phase}`)}</Text>
            {isOrdersLoaded && <Text style={styles.count}>{count}</Text>}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: ColorEnum.WHITE,
        paddingHorizontal: 16,
        paddingTop: 24,
        paddingBottom: 4,
        marginBottom: 12,
        gap: 8,
    },
    title: {
        color: ColorEnum.GRAY_900,
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 14,
        textTransform: 'uppercase',
    },
    count: {
        color: ColorEnum.EMERALD_700,
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 14,
    },
})

export default memo(OrdersListSectionHeader)
